//@flow

import type {HttpError} from '../../../../entities';

export const SCHEDULE_MESSAGE_FORM_FIELDS = {
  MESSAGE: 'message',
  SEND_DATE: 'date',
  SEND_TYPE: 'sendType',
  SEND_TIME: 'time',
};

export function getScheduleErrorMessage(error: HttpError): string {
  if (error.message === "Scheduled date can't be less than now") {
    return 'El mensaje programado no puede ser menor a la fecha actual';
  }

  return 'Error al crear el mensaje programado';
}
